exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.location-name[data-v-77315d6e] {\n  font-weight: 500;\n}\n.order-destination[data-v-77315d6e] {\n  margin-bottom: 1em;\n}\n", "", {"version":3,"sources":["/home/runner/work/online-store/online-store/src/components/checkout/OrderDestination.vue"],"names":[],"mappings":";AAAA;EACE,iBAAiB;CAAE;AAErB;EACE,mBAAmB;CAAE","file":"OrderDestination.vue","sourcesContent":[".location-name {\n  font-weight: 500; }\n\n.order-destination {\n  margin-bottom: 1em; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77315d6e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/checkout/OrderDestination.vue
// module id = 2KX/
// module chunks = 18